const moduleIcons = {
  namespaced: true,
  state: {
    plot_type: {
      forest: {
        default: {
          en: require('plot_icons/forest_en.svg'),
          al: require('plot_icons/forest_al.svg')
        },
        grey: {
          en: require('plot_icons/forest_grey_en.svg'),
          al: require('plot_icons/forest_grey_al.svg')
        }
      },
      pastures: {
        default: {
          en: require('plot_icons/pastures_en.svg'),
          al: require('plot_icons/pastures_al.svg')
        },
        grey: {
          en: require('plot_icons/pastures_grey_en.svg'),
          al: require('plot_icons/pastures_grey_al.svg')
        }
      },
      shrubs: {
        default: {
          en: require('plot_icons/shrubs_en.svg'),
          al: require('plot_icons/shrubs_al.svg')
        },
        grey: {
          en: require('plot_icons/shrubs_grey_en.svg'),
          al: require('plot_icons/shrubs_grey_al.svg')
        }
      },
      nonwood: {
        default: {
          en: require('plot_icons/nonwood_en.svg'),
          al: require('plot_icons/nonwood_al.svg')
        },
        grey: {
          en: require('plot_icons/nonwood_grey_en.svg'),
          al: require('plot_icons/nonwood_grey_al.svg')
        }
      }
    },
    event_type: {
      fire: {
        default: {
          en: require('event_icons/fire_en.svg'),
          al: require('event_icons/fire_al.svg')
        },
        grey: {
          en: require('event_icons/fire_grey_en.svg'),
          al: require('event_icons/fire_grey_al.svg')
        }
      },
      erosion: {
        default: {
          en: require('event_icons/erosion_en.svg'),
          al: require('event_icons/erosion_al.svg')
        },
        grey: {
          en: require('event_icons/erosion_grey_en.svg'),
          al: require('event_icons/erosion_grey_al.svg')
        }
      },
      other: {
        default: {
          en: require('event_icons/other_en.svg'),
          al: require('event_icons/other_al.svg')
        },
        grey: {
          en: require('event_icons/other_grey_en.svg'),
          al: require('event_icons/other_grey_al.svg')
        }
      },
      illegal_cut: {
        default: {
          en: require('event_icons/illegal_cut_en.svg'),
          al: require('event_icons/illegal_cut_al.svg')
        },
        grey: {
          en: require('event_icons/illegal_cut_grey_en.svg'),
          al: require('event_icons/illegal_cut_grey_al.svg')
        }
      }
    }
  },
  mutations: {
  },
  actions: {
  }
}

export default moduleIcons
